export function useUser() {
	return {
		user: useProperty('security.user') as Ref<App.Data.User.UserData>,
	}
}
